import { useContext } from 'react';
import { UserContext } from '../../../global/globalContext/context';
import { showMsg } from '../../../global/langs/langs';
import styles from '../ProductPage.module.scss';
import { Link } from 'react-router-dom';

export default function TitleSection(props) {
    const { lang } = useContext(UserContext);

  return (
    <>
        <span className={`${styles.rightDivider} ${styles.dark} ${styles.sectionTitle} pe-2 me-2`}>
            {showMsg(`${props.title}`, lang)}
        </span>
        <Link  
          to={`/product-list/${props.categoryId}`}
          className={`${styles.lgtLink}`}
        >
            {showMsg(`${props.linkText}`, lang)}
            <i className="bi bi-chevron-right ps-2"></i>
        </Link>
    </>
  )
}
